import pushToAMS from './pushToAMS'
import sharePdfCsv from './sharePdfCsv'
import documents from './documents'
import setVehicleInfo from './setVehicleInfo'
import type { MutationResolvers } from '../../../../generated/graphql'

const Mutation: MutationResolvers = {
    ...documents,
    pushToAMS,
    setVehicleInfo,
    sharePdfCsv,
}

export default Mutation
